import ButtonDropdownItem from './ButtonDropdownItem';

class ButtonDropdownSection {
  id: string;
  text: string;
  disabled: boolean = false;
  items: ButtonDropdownItem[];

  constructor(id: string, text: string, items: ButtonDropdownItem[], disabled?: boolean) {
    this.id = id;
    this.text = text;
    this.items = items;
    this.disabled = disabled || false;
  }
}

export default ButtonDropdownSection;
